var LocalStoragePersistentStorage = (function () {
    function LocalStoragePersistentStorage() {
    }
    LocalStoragePersistentStorage.prototype.setItem = function (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
        return true;
    };
    LocalStoragePersistentStorage.prototype.getItem = function (key) {
        var stored = localStorage.getItem(key);
        return stored ? JSON.parse(stored) : null;
    };
    return LocalStoragePersistentStorage;
}());
export { LocalStoragePersistentStorage };
export var localPersistentStorage = new LocalStoragePersistentStorage();
//# sourceMappingURL=storage.js.map